import { h } from 'preact';
import Loadable from 'react-loadable';

export default Loadable({
    loader: () => import('../../../../q-cars/src/containers/RTO/rto.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        let RTO = loaded.default;
        return <RTO {...props} />;
    }
});


// WEBPACK FOOTER //
// ../q-cars/src/containers/RTO/index.js